import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getEnvironment } from "../../../../Redux/reducer/env";
import { selectCountry } from "../../../../Redux/actions/sessionActions";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import ShowIcon from "../../../../../static/images/Show.svg";
import UserIcon from "../../../../../static/images/user-icon.svg";
import LockIcon from "../../../../../static/images/lock-icon.svg";
import CloseIcon from "../../../../../static/images/close-icon.svg";

import login from "../../../utils/cert.json";
import ErrorMessage from "../../custom-components/errorMessage";
import RadioOptionSelector from "../../custom-components/RadioOptionSelector";

const CustomerLoginForm = ({
  userType,
  redirectTo,
  handleLogin,
  httpResponseCode,
  ...props
}) => {
  const { t } = useTranslation();
  const [loginSuccess, setLoginSuccess] = useState(true);
  const [loginMessage, setLoginMessage] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [hiddenPassword, setHiddenPassword] = useState(true);
  const [country, setCountry] = useState("");
  const [radioSelectorProps, setRadioSelectorProps] = useState({
    containerClassName: "",
    titleClassName: "country-title",
    title: t("general.headers.country"),
    input1: {
      id: "cr",
      value: "CR",
      label: t("landing.country.CR"),
    },
    input2: {
      id: "pa",
      value: "PA",
      label: t("landing.country.PA"),
    },
  });
  const [credentials, setCredentials] = useState({
    username: "",
    key: "",
    formValidation: "RFToken"
  });

  const [errors, setErrors] = useState({
    country: "",
    username: "",
    key: "",
  });

  useEffect(() => {
    setCredentials({...credentials, username: "", key: "" });

    if (userType === "CSA") {
      setCountry("");
      props.selectCountry("");
    } else {
      setCountry("CR");
      props.selectCountry("CR");
    }
  }, [userType]);

  useEffect(() => {
    if (httpResponseCode === 403) {
      setLoginMessage(t("login.errors.failMessage"));
    }

    if (httpResponseCode === 409) {
      setLoginMessage(t("login.errors.409Message"));
    }
  }, [httpResponseCode]);

  useEffect(() => {
    if (
      !loginSuccess &&
      credentials.key === "" &&
      credentials.username === ""
    ) {
      setLoginSuccess(true);
    }

    if (credentials.username === "" || credentials.key === "") {
      setDisabledBtn(true);
    }

    if (credentials.username !== "" && credentials.key !== "") {
      setDisabledBtn(false);
    }
  }, [credentials]);

  useEffect(() => {
    if (country === "PA" && userType === "CSA") {
      window.location.href = `${
        login.login[props.env].cams
      }aos/login.bns?spEntityId=REVFACTORING&countryId=RFPA&locale=es&isMultiCountry=false`;
    }
  }, [country]);

  useEffect(() => {
    let emptySelectionClassName = "";
    emptySelectionClassName =
      userType === "CSA" && (country === "" || country === "PA")
        ? "no-country-input-selected"
        : "";

    setRadioSelectorProps({
      ...radioSelectorProps,
      containerClassName: emptySelectionClassName,
    });
  }, [userType, country]);

  const onSubmit = async (event) => {
    const token = credentials.formValidation;
    event.preventDefault();
    if (country === "") {
      errors["country"] = `${t("login.forms.errors.required")}`;
    }
    if (credentials.username === "") {
      errors["username"] = `${t("login.forms.errors.required")}`;
    }
    if (credentials.key === "") {
      errors["key"] = `${t("login.forms.errors.required")}`;
    }
    setErrors({ ...errors });

    for (let error in errors) {
      if (errors[error] !== "") {
        return;
      }
    }

    setLoginSuccess(true);
    setShowLoading(true);
    const result = await handleLogin(credentials.username, credentials.key, token);
    if (!result) {
      setLoginSuccess(false);
    }
    setShowLoading(false);
  };

  const clearInput = (inputName) => {
    return credentials[`${inputName}`] !== "" ? (
      <span
        className="button input-w-aux__action clear-user transparent-btn"
        onClick={() => setCredentials({ ...credentials, [inputName]: "" })}
      >
        <img
          src={CloseIcon}
          alt={`${t("general.labels.clear")}`}
        />
      </span>
    ) : null;
  };

  const seeButton = () => {
    return credentials.key !== "" ? (
      <span
        className="button input-w-aux__action see-password see-btn transparent-btn"
        type="button"
        onClick={() => setHiddenPassword(!hiddenPassword)}
      >
        <img src={ShowIcon} alt={`${t("general.labels.clear")}`} />
      </span>
    ) : null;
  };

  const handleCountry = (event) => {
    if (errors["country"] != "") {
      errors["country"] = "";
      setErrors({ ...errors });
    }

    setCountry(event.target.value);
    props.selectCountry(event.target.value);
  };

  const handleCredentials = (event) => {
    const inputName = event.target.name;
    if (errors[inputName] != "") {
      errors[inputName] = "";
      setErrors({ ...errors });
    }
    setCredentials({ ...credentials, [inputName]: event.target.value });
  };

  const displayError = (inputName) => {
    return errors[inputName] !== "" ? (
      <ErrorMessage
        imgClassNames={["error-icon-size"]}
        errorContainerClassName="error-content"
        error={errors[inputName]}
      />
    ) : null;
  };

  const loginLoading = (text) => {
    return (
      <div
        className={`login-loading ${
          userType === "CSA" ? "csa-loading" : "pro-loading"
        }`}
      >
        <p className="login-loading-message">Estamos redigiriendo a</p>
        <p className="login-loading-message last">Reverse Factoring</p>
        <div className="loader"></div>
        <p>{text}</p>
      </div>
    );
  };

  return (
    <>
      <div
        className={`login-form customer-login-form margin-centered ${
          (country === "" || country === "PA") && userType === "CSA"
            ? "csa-padding"
            : ""
        }`}
      >
        <h5>{t("login.banner.title")}</h5>
        <h3>{t("appName")}</h3>
        <h4>
          {userType === "CSA"
            ? t("landing.options.clients")
            : t("landing.options.suppliers")}
        </h4>
        {showLoading && loginLoading()}
        {!showLoading && (
          <form
            id="submit-form"
            className={`full-width login ${
              userType === "CSA" && country === "PA"
                ? "csa-pa-country-form"
                : ""
            } ${
              userType === "CSA" && country === "" ? "csa-no-country-form" : ""
            }`}
            method="POST"
            onSubmit={(event) => onSubmit(event)}
          >
            <input type="hidden" name="_csrf" value={credentials.formValidation}/>

            <RadioOptionSelector
              selected={country}
              handleChange={handleCountry}
              radioSelectorProps={radioSelectorProps}
            />
            {displayError("country")}
            {((userType === "CSA" && country === "CR") ||
              userType === "PRO") && (
              <>
                <div
                  className={`input-container input-column ${
                    userType === "CSA"
                      ? "csa-input-separator"
                      : "pro-input-separator"
                  }`}
                >
                  <p>{t("login.forms.userLbl")}</p>
                  <div className="input-w-aux no-margin">
                    <img
                      className="button input-w-aux__icon"
                      src={UserIcon}
                      alt={t(`login.forms.userLbl`)}
                    />
                    <input
                      id="username"
                      name="username"
                      type="text"
                      className={`input input--text input-w-aux__input input--active ${
                        !loginSuccess ? "red-box" : ""
                      }`}
                      autoComplete="off"
                      value={credentials.username}
                      onChange={(event) => handleCredentials(event)}
                    />
                    {clearInput("username")}
                  </div>
                  {displayError("username")}
                </div>
                <div
                  className={`input-container input-column ${
                    userType === "CSA"
                      ? "csa-input-separator"
                      : "pro-input-separator"
                  }`}
                >
                  <p>{t("login.forms.passwordLbl")}</p>
                  <div className="input-w-aux no-margin">
                    <img
                      className="button input-w-aux__icon"
                      src={LockIcon}
                      alt={`${t("general.labels.clear")}`}
                    />
                    <input
                      id="key"
                      name="key"
                      className={`input input--text input-w-aux__input ${
                        !loginSuccess ? "red-box" : ""
                      }`}
                      type={hiddenPassword ? "password" : "text"}
                      autoComplete="off"
                      value={credentials["key"]}
                      onChange={(event) => handleCredentials(event)}
                    />
                    {seeButton()}
                    {clearInput("key")}
                    {displayError("key")}
                  </div>
                </div>
                {!loginSuccess && (
                  <div style={{ marginTop: "1.5rem" }}>
                    <ErrorMessage
                      imgClassNames={["error-icon-size"]}
                      errorContainerClassName="error-content"
                      error={loginMessage}
                    />
                  </div>
                )}
                <div
                  className={`links-container 
                  ${
                    userType === "CSA"
                      ? loginSuccess
                        ? "csa-links"
                        : "csa-error-links"
                      : ""
                  }
                  `}
                >
                  <p className="forgot-pass p-margin">
                    <Link to="/user/reset-password">
                      {`${t("login.forms.links.passwordRecovery")}`}
                    </Link>
                  </p>
                  {userType === "PRO" && (
                    <p>
                      {t("login.forms.links.newAccount")} &nbsp;
                      <Link to={"/register/new-provider"}>
                        {t("login.forms.links.signupNow")}
                      </Link>
                    </p>
                  )}
                </div>
              </>
            )}
            <div
              className={`form-actions-container ${
                userType === "CSA" && country == ""
                  ? "csa-no-country-selected"
                  : "login-btn"
              } ${
                userType === "CSA"
                  ? country == "PA"
                    ? "pa-static-position"
                    : ""
                  : ""
              }`}
            >
              <PrimaryButton
                disabled={
                  country == "" ||
                  (userType === "CSA" && country === "PA") ||
                  disabledBtn
                }
              >
                {t("login.loginBtn")}
              </PrimaryButton>
            </div>
          </form>
        )}
      </div>
      <div className="redirect-link-container">
        <p className="text-underline">
          <Link
            id={redirectTo}
            to={{
              pathname: `/${
                redirectTo === "clients" ? "clients" : "providers"
              }/login`,
            }}
          >
            {`${
              t("landing.goTo") +
              " " +
              t("appName") +
              " - " +
              t(`landing.options.${redirectTo}`)
            }`}
          </Link>
        </p>
      </div>
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    env: getEnvironment(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    selectCountry: (payload) => dispatch(selectCountry(payload)),
  };
};

CustomerLoginForm.propTypes = {
  userType: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  env: PropTypes.string,
  handleLogin: PropTypes.func.isRequired,
  httpResponseCode: PropTypes.number.isRequired,
  selectCountry: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatch)(CustomerLoginForm);
